module.exports = __webpack_public_path__ + "static/media/7-6.b74cffe4.mp3";